/* wg-pdp-head.js - Wade Greens
   Moves the product title block above the gallery on phones and tablets.
   Read assets/wg-pdp-head.css first - it records the measurements and explains
   why this cannot be done in CSS alone.

   WHAT MOVES, in this order, into a new .wg-pdp-head wrapper:
     .pdp-corner-breadcrumb        (absolute, top-right)
     the product type row          ("Saplings")
     the title + badge row         (title, Zones, Live Plant)
     the review-stars app block
     the price row
     .pdp-share-corner             (absolute, top 14px right 0)
   Everything after the price - description, quantity, variants, add to cart -
   stays in .productView-details and renders below the gallery.

   The two absolutely-positioned nodes are carried along deliberately: the CSS
   makes .wg-pdp-head position:relative so it becomes their containing block
   and they keep the same offsets they had against .productView-product.

   IT IS REVERSIBLE. Every moved node's original parent and nextSibling are
   recorded, and crossing back above 1024px puts them back in place before the
   wrapper is removed. That matters because the desktop PDP is a two-column
   layout that depends on this markup being where the section printed it.

   THE DUPLICATE SHARE GUARD. Measured: load the page at desktop width, then
   narrow it past 1024px, and .pdp-share-corner goes from 1 to 2. The theme's
   own breakpoint handler finds no share control inside .productView-product -
   because this script just moved it into .wg-pdp-head - and prints a second
   one. Verified against v1.69, which has no wg-pdp-head and stays at 1. A
   phone never does this (it loads narrow and stays narrow), but a desktop
   browser being dragged narrower does, so dedupe() hides any share control
   that is NOT the one inside the wrapper, marks it data-wg-dupe, and restore()
   un-hides every marked node. It only ever hides when the wrapper holds one,
   so the control can never vanish entirely. Nothing is deleted.

   The block count is taken from the DOM rather than hardcoded class names: the
   breadcrumb and the share corner are identified by class, and the four rows
   between them are simply the first four remaining children. The theme prints
   them in that order, and sections/main-product.liquid is 140KB - past the
   Admin API write ceiling - so the markup cannot be given hooks of its own.
*/
(function () {
  var MQ = '(max-width: 1024px)';
  var mq = window.matchMedia ? window.matchMedia(MQ) : null;
  var head = null;
  var saved = [];
  var timer = null;

  function dedupe() {
    if (!head || !head.parentNode) return;
    var mine = head.querySelector('.pdp-share-corner');
    if (!mine) return;
    var all = document.querySelectorAll('.pdp-share-corner');
    for (var i = 0; i < all.length; i++) {
      if (all[i] === mine) continue;
      if (all[i].getAttribute('data-wg-dupe')) continue;
      all[i].setAttribute('data-wg-dupe', '1');
      all[i].style.display = 'none';
    }
  }

  function undupe() {
    var all = document.querySelectorAll('[data-wg-dupe]');
    for (var i = 0; i < all.length; i++) {
      all[i].style.display = '';
      all[i].removeAttribute('data-wg-dupe');
    }
  }

  function build() {
    if (head) return;
    var top = document.querySelector('.productView-top');
    if (!top) return;
    var left = top.querySelector('.halo-productView-left');
    var prod = top.querySelector('.productView-product');
    if (!left || !prod || left.parentNode !== top) return;

    var crumb = null, share = null, rest = [];
    var i, n, kids = [].slice.call(prod.children);
    for (i = 0; i < kids.length; i++) {
      n = kids[i];
      if (n.classList.contains('pdp-corner-breadcrumb')) crumb = n;
      else if (n.classList.contains('pdp-share-corner')) share = n;
      else rest.push(n);
    }

    var take = [];
    if (crumb) take.push(crumb);
    take = take.concat(rest.slice(0, 4));
    if (share) take.push(share);
    if (!take.length) return;

    head = document.createElement('div');
    head.className = 'wg-pdp-head';
    saved = [];
    for (i = 0; i < take.length; i++) {
      n = take[i];
      if (!n) continue;
      saved.push({ node: n, parent: n.parentNode, next: n.nextSibling });
      head.appendChild(n);
    }
    top.insertBefore(head, left);
    dedupe();
    if (timer) clearTimeout(timer);
    timer = setTimeout(dedupe, 800);
  }

  function restore() {
    if (!head) return;
    if (timer) { clearTimeout(timer); timer = null; }
    undupe();
    for (var i = saved.length - 1; i >= 0; i--) {
      var s = saved[i];
      if (s.parent) s.parent.insertBefore(s.node, s.next);
    }
    if (head.parentNode) head.parentNode.removeChild(head);
    head = null;
    saved = [];
  }

  function sync() {
    if (!mq) return;
    if (mq.matches) build(); else restore();
  }

  function start() {
    sync();
    if (!mq) return;
    if (mq.addEventListener) mq.addEventListener('change', sync);
    else if (mq.addListener) mq.addListener(sync);
    window.addEventListener('resize', function () {
      if (head) { if (timer) clearTimeout(timer); timer = setTimeout(dedupe, 400); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
